import { useEffect } from 'react';
import { useMessage } from '../global-components/src';
import {
    ClientProtectionBlockReason,
    installClientProtection,
} from '../security/client-protection';

const messages: Record<ClientProtectionBlockReason, string> = {
    'automated-interaction': 'Ação automática bloqueada.',
    'interaction-rate': 'Muitas ações em pouco tempo. Aguarde alguns segundos.',
    'unsafe-paste': 'A colagem de conteúdo com script foi bloqueada por segurança.',
    'untrusted-submit': 'Envio não confiável bloqueado por segurança.',
};

const ClientProtection = () => {
    const { setMessage } = useMessage();

    useEffect(() => installClientProtection(reason => {
        setMessage(messages[reason], 'warning');
    }), [setMessage]);

    return null;
};

export default ClientProtection;
